import { CANVAS_ZOOM } from "../canvas-controls.config";

/** Discrete zoom percentages within CANVAS_ZOOM min/max. */
export const CANVAS_ZOOM_STEPS = [
  5, 10, 25, 50, 75, 100, 125, 150, 175, 200, 250, 300, 400,
] as const;

export function zoomLevelToPercent(zoom: number): number {
  return Math.round(zoom * 100);
}

export function clampZoomPercent(percent: number): number {
  const min = Math.ceil(CANVAS_ZOOM.minZoom * 100);
  const max = Math.floor(CANVAS_ZOOM.maxZoom * 100);
  return Math.min(max, Math.max(min, percent));
}

export function nearestZoomStepPercent(percent: number): number {
  const clamped = clampZoomPercent(percent);
  let best: number = CANVAS_ZOOM_STEPS[0];
  let bestDist = Math.abs(clamped - best);
  for (const step of CANVAS_ZOOM_STEPS) {
    const dist = Math.abs(clamped - step);
    if (dist < bestDist) {
      best = step;
      bestDist = dist;
    }
  }
  return best;
}

export function stepZoomPercent(percent: number, direction: -1 | 1): number {
  const clamped = clampZoomPercent(percent);
  const current = nearestZoomStepPercent(clamped);
  const idx = CANVAS_ZOOM_STEPS.indexOf(
    current as (typeof CANVAS_ZOOM_STEPS)[number],
  );
  const nextIdx = Math.min(
    CANVAS_ZOOM_STEPS.length - 1,
    Math.max(0, idx + direction),
  );
  return CANVAS_ZOOM_STEPS[nextIdx] ?? current;
}

export function canStepZoomOut(percent: number): boolean {
  const current = nearestZoomStepPercent(percent);
  const idx = CANVAS_ZOOM_STEPS.indexOf(
    current as (typeof CANVAS_ZOOM_STEPS)[number],
  );
  return idx > 0;
}

export function canStepZoomIn(percent: number): boolean {
  const current = nearestZoomStepPercent(percent);
  const idx = CANVAS_ZOOM_STEPS.indexOf(
    current as (typeof CANVAS_ZOOM_STEPS)[number],
  );
  return idx < CANVAS_ZOOM_STEPS.length - 1;
}
